import * as React from "react";
//UI Frameworks
import { FormComponentProps } from "antd/lib/form";
import { Form, Input as AntdInput } from "antd";
//shared components
import Button from "components/Button";
//styles
import styles from "./index.module.scss";

interface IProps extends FormComponentProps {
	onSubmit: (data: any) => void;
	loading: boolean;
}
const GetPassword: React.FC<IProps> = props => {
	const { getFieldDecorator } = props.form;
	// const [confirmDirty, setConfirmDirty] = React.useState();

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		props.form.validateFields((err, values) => {
			if (!err) {
				props.onSubmit({ newPassword: values.newPassword, key: Number(values.key) });
			}
		});
	}

	// function handleConfirmBlur(e: React.FormEvent<HTMLInputElement>) {
	// 	const { value } = e.currentTarget;

	// 	setConfirmDirty(confirmDirty || !!value);
	// }

	function validateToNextPassword(_: any, value: string, callback: any) {
		if (!value) {
			callback(" لطفا رمز عبور خود را وارد نمایید");
		} else if (value && value.length < 6) {
			callback("رمز عبور باید باید حداقل از 6 حرف تشکیل شده باشد");
		} else if (value && value.length >= 6) {
			props.form.validateFieldsAndScroll(["confirmNewPassword"], { force: true });

			callback();
		}
	}

	function compareToFirstPassword(_: any, value: string, callback: any) {
		if (!value) {
			callback("لطفا تکرار رمز عبور خود را وارد نمایید");
		} else if (value && value !== props.form.getFieldValue("newPassword")) {
			callback("پسوردهای وارد شده یکسان نمی باشند!");
		} else {
			callback();
		}
	}
	
	return (
		<Form onSubmit={handleSubmit} className={styles["password-reset-form"]}>
			<Form.Item label=" رمز عبور ">
				{getFieldDecorator("newPassword", {
					rules: [
						{
							transform: value => (value ? value.trim() : value),
						},
						{
							validator: validateToNextPassword,
						},
					],
				})(<AntdInput.Password />)}
			</Form.Item>
			<Form.Item label="تکرار رمز عبور">
				{getFieldDecorator("confirmNewPassword", {
					rules: [
						{
							transform: value => (value ? value.trim() : value),
						},
						{
							validator: compareToFirstPassword,
						},
					],
				})(<AntdInput.Password />)}
			</Form.Item>

			<Form.Item className="button-center">
				<Button htmlType="submit" primary loading={props.loading}>
					تغییر رمز عبور
				</Button>
			</Form.Item>
		</Form>
	);
};

export default Form.create<IProps>()(React.memo(GetPassword));
